import React from 'react';
import { styled } from '@mui/system';
import Box from '@mui/material/Box';
import { Close as CloseIconOutlined } from "@mui/icons-material";

const ErrorBox = styled(Box)(() => ({
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'var(--red1)',
    color: 'white',
    borderRadius: '8px',
    padding: '16px',
    boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
}));

const SuccessMessage = ({ message }) => {
    return (
        <ErrorBox>
            <CloseIconOutlined style={{ fontSize: 48, marginRight: 8 }} />
            {message}
        </ErrorBox>
    );
};

export default SuccessMessage;
